import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents';
import Moment from 'moment';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../constants/colors';
import { axiosPath, path } from '../../../../../routing/helpers/router';
import { getResourceManagerFilterInitialValues } from '../../../../../minions/forms';
import Translator from '../../../../components/helpers/Translator';
import errorHandler from '@/layout/components/error/ErrorHandler';
import useIsMounted from '../../../../components/hooks/useIsMounted';

export default function NavBarResourceManager({ view }) {
  const { moduleBridgeHex } = useParams();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [navbarInfo, setNavbarInfo] = useState();

  // > GET NARVBAR INFO
  const getNavbarInfo = useCallback(
    () =>
      axios
        .post(axiosPath('api_r_user_module_resourceManager_getNavbarInfo'), {
          moduleBridgeHex,
          view,
        })
        .then(({ data }) => {
          if (isMounted.current) setNavbarInfo(data);
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, view]
  );

  useEffect(() => {
    getNavbarInfo();
  }, []);
  // < GET NARVBAR INFO

  // > GENERATE FILTER HEX CODE
  const generateFilterHexCode = async (values) => {
    const filters = {
      ...getResourceManagerFilterInitialValues(),
      ...values,
    };

    try {
      const response = await axios.post(
        axiosPath('api_r_user_module_resourceManager_generateFilterHexCode'),
        { moduleBridgeHex, filters }
      );

      navigate(
        path({
          name:
            view === 'resource'
              ? 'user_module_resourceManager_resource_home'
              : 'user_module_resourceManager_obligation_home',
          params: {
            moduleBridgeHex,
            page: 1,
            filtersHex: response.data.hexCode,
          },
        })
      );
    } catch (err) {}
  };
  // < GENERATE FILTER HEX CODE

  const getLastThreeMonthsModifiedObligations = () => {
    generateFilterHexCode({
      obligationModificationFrom: Moment().subtract(3, 'months').unix(),
      obligationModificationTo: Moment().unix(),
    });
  };
  const getUnfilledResources = () => {
    generateFilterHexCode({
      states: [-1, 2, 3],
    });
  };

  return (
    <Container>
      {view === 'resource' && (
        <NavbarIcon
          title={`${navbarInfo?.unfilledResources} ${ReactDOMServer.renderToString(
            <Translator
              file="module-resourceManager"
              name="resource.unfilled.resources"
            />
          )}`}
          className={!navbarInfo?.unfilledResources ? 'off' : ''}
          onClick={getUnfilledResources}
        >
          <AppRemixIcon
            icon="alert"
            size={20}
            filled={navbarInfo?.unfilledResources}
            color={navbarInfo?.unfilledResources && colors.danger}
          />
          {navbarInfo?.unfilledResources > 0 && (
            <>
              {navbarInfo.unfilledResources > 99 ? (
                <span className="badge">+99</span>
              ) : (
                <span className="badge">{navbarInfo.unfilledResources}</span>
              )}
            </>
          )}
        </NavbarIcon>
      )}
      {view === 'obligation' && (
        <NavbarIcon
          title={`${navbarInfo?.unfilledResources} ${ReactDOMServer.renderToString(
            <Translator
              file="module-resourceManager"
              name="resource.unfilled.obligations"
            />
          )}`}
          className={!navbarInfo?.unfilledResources ? 'off' : ''}
          onClick={getUnfilledResources}
        >
          <AppRemixIcon
            icon="alert"
            size={20}
            filled={navbarInfo?.unfilledResources}
            color={navbarInfo?.unfilledResources && colors.danger}
          />
          {navbarInfo?.unfilledResources > 0 && (
            <>
              {navbarInfo.unfilledResources > 99 ? (
                <span className="badge">+99</span>
              ) : (
                <span className="badge">{navbarInfo.unfilledResources}</span>
              )}
            </>
          )}
        </NavbarIcon>
      )}
      <NavbarIcon
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-legalCompliance"
            name="new.obligations.latest.three.months"
          />
        )}
        className={!navbarInfo?.lastThreeMonthsModifiedObligations ? 'off' : ''}
        onClick={getLastThreeMonthsModifiedObligations}
      >
        <AppRemixIcon
          icon="notification-2"
          size={20}
          filled={navbarInfo?.lastThreeMonthsModifiedObligations}
          color={
            navbarInfo?.lastThreeMonthsModifiedObligations &&
            colors.modifiedObligations
          }
        />
        {navbarInfo?.lastThreeMonthsModifiedObligations > 0 && (
          <>
            {navbarInfo.lastThreeMonthsModifiedObligations > 99 ? (
              <span className="badge">+99</span>
            ) : (
              <span className="badge">
                {navbarInfo.lastThreeMonthsModifiedObligations}
              </span>
            )}
          </>
        )}
      </NavbarIcon>
    </Container>
  );
}

const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 15px;
  color: white;
  li {
    display: inline-block;
    padding: 0 6px;
  }
  li + li {
    border-left: 2px solid ${colors.primaryLight};
  }
  li.off {
    opacity: 0.2;
  }
`;

const NavbarIcon = styled.li`
  position: relative;
  &:hover {
    cursor: pointer;
  }
  .badge {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #f4f6f9;
    border-radius: 100px;
    color: ${colors.primary};
    font-size: 9px;
    padding: 2px;
    width: 15px;
    height: 15px;
    text-align: center;
  }
`;
